import React from 'react'
import { storiesOf } from '@storybook/react'
import withReadme from 'storybook-readme/with-readme'

// Digital-Commons Theming
import { ThemeProvider } from 'styled-components'
import { getBaseTheme } from '../..'

// Component to surface in storybook
import ButtonBase from '.'
import readme from './readme.md'

// Story Setup
const stories = storiesOf('Digital-Commons/ButtonBase', module)

stories.addDecorator(withReadme(readme))

// Theming setup
const mode = 'refinitiv'
const baseTheme = getBaseTheme({ mode })
const builtTheme = {
  mode,
  ...baseTheme
}

const _onSubmit = e => {
  window.alert('Submit!')
}

const _disabledLinkClick = e => {
  e.preventDefault()
}

// Stories
stories
  .add('Regular', () => (
    <ThemeProvider theme={builtTheme}>
      <ButtonBase>Regular Button</ButtonBase>
    </ThemeProvider>
  ))
  .add('Disabled', () => (
    <ThemeProvider theme={builtTheme}>
      <ButtonBase disabled>Disabled Button</ButtonBase>
    </ThemeProvider>
  ))
  .add('Submit', () => (
    <ThemeProvider theme={builtTheme}>
      <form onSubmit={_onSubmit}>
        <ButtonBase type='submit'>Submit Button</ButtonBase>
      </form>
    </ThemeProvider>
  ))
  .add('Link', () => (
    <ThemeProvider theme={builtTheme}>
      <ButtonBase href='foo.html'>Link Button</ButtonBase>
    </ThemeProvider>
  ))
  .add('Link Disabled', () => (
    <ThemeProvider theme={builtTheme}>
      <ButtonBase disabled onClick={_disabledLinkClick} href='bar.html'>
        Disabled Link Button
      </ButtonBase>
    </ThemeProvider>
  ))
